var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row text-center py-3" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("i", { staticClass: "fas fa-volume-up" }),
      _vm._v(" "),
      _c("span", { staticClass: "text-uppercase ms-2" }, [
        _vm._v("\n      " + _vm._s(_vm.component.text || _vm.type) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 mt-4" }, [
      _c(
        "audio",
        {
          ref: "audio",
          staticStyle: { width: "100%" },
          attrs: { controls: "", controlsList: "nodownload", src: _vm.path },
        },
        [
          _vm._v("\n        Your browser does not support the\n        "),
          _c("code", [_vm._v("audio")]),
          _vm._v("\n        element.\n      "),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.component.data.download
      ? _c("div", { staticClass: "col-12 mt-4" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-primary",
              attrs: {
                href: _vm.path,
                download: _vm.filename,
                target: "_blank",
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm._f("translate")("Download")) + "\n    "
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }